import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { actualites } from '../data/actualites';

const NextArrow = ({ onClick }) => (
  <button onClick={onClick} style={{
    position: 'absolute', right: '-18px', top: '50%', transform: 'translateY(-50%)',
    width: '36px', height: '36px', borderRadius: '50%',
    backgroundColor: '#4A9E47', border: 'none', cursor: 'pointer',
    color: '#fff', fontSize: '18px', fontWeight: 'bold',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: '0 2px 10px rgba(58,166,55,0.5)', zIndex: 10,
    lineHeight: 1
  }}>›</button>
);

const PrevArrow = ({ onClick }) => (
  <button onClick={onClick} style={{
    position: 'absolute', left: '-18px', top: '50%', transform: 'translateY(-50%)',
    width: '36px', height: '36px', borderRadius: '50%',
    backgroundColor: '#4A9E47', border: 'none', cursor: 'pointer',
    color: '#fff', fontSize: '18px', fontWeight: 'bold',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    boxShadow: '0 2px 10px rgba(58,166,55,0.5)', zIndex: 10,
    lineHeight: 1
  }}>‹</button>
);

function NewsCarousel() {
  const navigate = useNavigate();

  const goToArticle = (item) => {
    navigate('/actualites', { state: { scrollTo: `actu-${item.id}` } });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: dots => (
      <div style={{ bottom: '-30px' }}>
        <ul style={{ margin: 0, padding: 0, display: 'flex', justifyContent: 'center', gap: '6px' }}>
          {dots}
        </ul>
      </div>
    ),
    customPaging: () => (
      <div style={{
        width: '8px', height: '8px', borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.3)',
        transition: 'background-color 0.3s'
      }} />
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <>
      <style>{`
        .news-slick .slick-list {
          padding: 20px 0 !important;
        }
        .news-slick .slick-dots li.slick-active div {
          background-color: #4A9E47 !important;
        }
        .news-slick .slick-dots li div {
          width: 8px; height: 8px; border-radius: 50%;
        }
        .news-card {
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .news-card:hover {
          transform: translateY(-6px) scale(1.02);
          box-shadow: 0 8px 20px rgba(0,0,0,0.35), 0 -8px 20px rgba(0,0,0,0.35) !important;
        }
        .news-card:hover .card-read-more {
          color: #fff !important;
          letter-spacing: 1px;
        }
        .news-card:hover .card-green-bar {
          width: 100% !important;
        }
      `}</style>

      <div style={{ backgroundColor: "rgb(33, 46, 79)", paddingTop: "30px", paddingBottom: "60px" }}>
        {/* En-tête */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ width: '60px', height: '3px', backgroundColor: '#4A9E47', margin: '0 auto 12px' }} />
          <h2 style={{ color: "#fff", fontFamily: "Consolas, monospace", fontSize: '28px', margin: 0, letterSpacing: '2px' }}>
            ACTUALITÉS
          </h2>
          <div style={{ width: '60px', height: '3px', backgroundColor: '#4A9E47', margin: '12px auto 0' }} />
        </div>

        {/* Carousel */}
        <div className="news-slick" style={{ margin: '0 auto', width: '88%', position: 'relative' }}>
          <Slider {...settings}>
            {actualites.map((item, index) => (
              <div key={item.id}>
                <div
                  className="news-card"
                  onClick={() => goToArticle(item)}
                  style={{
                    margin: '0 16px',
                    backgroundColor: '#1e2b4e',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3), 0 -4px 12px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  {/* Image */}
                  <div style={{
                    position: 'relative',
                    aspectRatio: '4/3',
                    flexShrink: 0,
                    overflow: 'hidden',
                    backgroundColor: '#0e1530',
                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                  }}>
                    {item.images && item.images.length > 0 ? (
                      <img
                        src={item.images[0]}
                        alt={item.title}
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                      />
                    ) : (
                      <div style={{
                        width: '100%', height: '100%',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                      }}>
                        <span style={{ color: 'rgba(255,255,255,0.2)', fontFamily: 'Consolas', fontSize: '12px' }}>
                          {item.date}
                        </span>
                      </div>
                    )}
                    {/* Badge date */}
                    <span style={{
                      position: 'absolute', top: '12px', left: '12px',
                      backgroundColor: '#4A9E47',
                      color: '#fff', fontSize: '11px', fontWeight: 'bold',
                      fontFamily: 'Consolas, monospace',
                      padding: '3px 10px', borderRadius: '20px',
                      letterSpacing: '0.5px'
                    }}>
                      {item.date}
                    </span>
                  </div>

                  {/* Corps de la carte */}
                  <div style={{ padding: '16px 18px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <h4 style={{
                      color: '#fff', fontFamily: 'Consolas, monospace',
                      fontSize: '14px', fontWeight: 'bold',
                      margin: '0 0 10px 0', lineHeight: '1.4'
                    }}>
                      {item.title}
                    </h4>
                    <p style={{
                      fontSize: '13px', color: 'rgba(255,255,255,0.65)',
                      fontFamily: 'Consolas, monospace', lineHeight: '1.6',
                      margin: 0, flex: 1,
                      overflow: 'hidden',
                      display: '-webkit-box',
                      WebkitLineClamp: 4,
                      WebkitBoxOrient: 'vertical'
                    }}>
                      {item.excerpt}
                    </p>

                    {/* Barre + lien */}
                    <div style={{ marginTop: '14px' }}>
                      <div className="card-green-bar" style={{
                        height: '1px', backgroundColor: '#4A9E47',
                        width: '40px', marginBottom: '10px',
                        transition: 'width 0.3s ease'
                      }} />
                      <span className="card-read-more" style={{
                        fontSize: '12px', color: '#4A9E47',
                        fontFamily: 'Consolas, monospace', fontWeight: 'bold',
                        letterSpacing: '0.5px', transition: 'letter-spacing 0.3s, color 0.3s'
                      }}>
                        Lire la suite →
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </>
  );
}

export default NewsCarousel;
